import { IconArrowRight } from '../../icons/IconArrowRight'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ViewGuard } from '../../../../app/guards/ViewGuard'

export const EditCountriesButton = ({
  project,
}: {
  project: { value?: string | number; isDemo?: boolean }
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (!String(project.value)?.length || project.isDemo) {
    return null
  }

  return (
    <ViewGuard roles={['admin', 'editor']}>
      <button
        className={'flex w-full items-center justify-between px-[16px] py-[8px] text-default'}
        type={'button'}
        onClick={() => navigate(`/projects/${project.value}/locations`)}
      >
        {t('buttons.editCountries')}
        <div className={'w-[14px]'}>
          <IconArrowRight color={'#A059FF'} />
        </div>
      </button>
    </ViewGuard>
  )
}
